import { render } from "./generalLinks.vue?vue&type=template&id=7774ff5c"
import script from "./generalLinks.vue?vue&type=script&lang=js"
export * from "./generalLinks.vue?vue&type=script&lang=js"

import "./generalLinks.vue?vue&type=style&index=0&id=7774ff5c&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__